import { render, staticRenderFns } from "./OrdersTableDesktop.vue?vue&type=template&id=7f4309c4&scoped=true&"
import script from "./OrdersTableDesktop.vue?vue&type=script&lang=js&"
export * from "./OrdersTableDesktop.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=7f4309c4&scoped=true&lang=css&"
import style1 from "./OrdersTableDesktop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4309c4",
  null
  
)

export default component.exports